import { GridProps } from '@chakra-ui/react';
import { MDivider, MGrid } from '../../../components/Monetize';
import { HeaderCell } from '../../../components/Quotes';
import {
  HEADER_ROW_CELLS,
  QUOTE_GRID_TEMPLATE_COLUMNS,
} from '../../../constants/quotes';

interface QuoteFormOfferingTableHeaderProps extends GridProps {
  offeringTitle?: string;
}
export const QuoteFormOfferingTableHeader = ({
  offeringTitle,
  ...rest
}: QuoteFormOfferingTableHeaderProps) => {
  const headerCells = [...HEADER_ROW_CELLS];

  if (offeringTitle) {
    headerCells[0] = offeringTitle;
  }

  return (
    <MGrid
      gridTemplateColumns={QUOTE_GRID_TEMPLATE_COLUMNS}
      columnGap={6}
      rowGap={2}
      // Breathing room between the divider and the first rounded offering strip
      mb={1}
      {...rest}
    >
      {/* Quiet column headers so the offering names, not the labels, draw the eye */}
      {headerCells.map((cell: string, index: number) => (
        <HeaderCell
          value={cell}
          key={`${index}-${cell}`}
          fontSize="sm"
          fontWeight="600"
          color="fg.muted"
        >
          {cell}
        </HeaderCell>
      ))}
      <MDivider gridColumn="1/-1" />
    </MGrid>
  );
};
